module.exports = __webpack_public_path__ + "introduce-01.png?c3fd73cec8f4bd3ca24c0c04d2d737fb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/introduce-01.png
// module id = 135
// module chunks = 0